import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListTeknisiStaf, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import ProjectAntrianIndex from "../../pagesSub/trxProjectAntrian/ProjectAntrianIndex";
import ProjectPengerjaanIndex from "../../pagesSub/trxProjectPengerjaan/ProjectPengerjaanIndex";
import ProjectQCIndex from "../../pagesSub/trxProjectQC/ProjectQCIndex";
import SelesaiIndex from "../../pagesSub/trxSelesai/SelesaiIndex";
import SudahDiambilIndex from "../../pagesSub/trxSudahDiambil/SudahDiambilIndex";
import ProjectDibatalkanIndex from "../../pagesSub/trxDibatalkan/ProjectDibatalkanIndex";

import PopUpTeknisiTasks from "../../components/utilities/PopUpTeknisiTasks";
import PengecekanIndex from "../../pagesSub/home/pengecekan/PengecekanIndex";

import SerialNumberCheckerIndex from "../../pagesSub/serialNumberChecker/SerialNumberCheckerIndex";

const ProjectTS = () => {

  const { subMenu, tab } = useParams();
  const menu = menuListTeknisiStaf.project.slug;
  const roleUser = role.teknisi;
  const slugLink = roleUser.subLevel.teknisi_staf.slugLink;

  return (
    <LayoutAppShell
      stateMenuList={menuListTeknisiStaf}
      stateMenu={menu}
      stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
    >
      {menuListTeknisiStaf.project.subMenu.zero.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListTeknisiStaf}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.zero.tabs.one.flag}>
                {menuListTeknisiStaf.project.subMenu.zero.tabs.one.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.zero.tabs.one.flag}>
              <PengecekanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}
              />
            </Tabs.Panel>
          </Tabs>

          <PopUpTeknisiTasks />
        </React.Fragment>
      }

      {menuListTeknisiStaf.project.subMenu.one.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListTeknisiStaf}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />

            <WrapperTab
              stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
              stateKeepMounted={false}
            >
              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.two.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.two.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.three.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.three.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.four.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.four.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.five.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.five.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.six.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.six.name}
              </Tabs.Tab>

              <Tabs.Tab value={menuListTeknisiStaf.project.subMenu.one.tabs.seven.flag}>
                {menuListTeknisiStaf.project.subMenu.one.tabs.seven.name}
              </Tabs.Tab>
            </WrapperTab>
          </WrapperHeaderTab>

          <Tabs value={tab} keepMounted={false}>
            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.two.flag}>
              <ProjectAntrianIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.three.flag}>
              <ProjectPengerjaanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.four.flag}>
              <ProjectQCIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.five.flag}>
              <SelesaiIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.six.flag}>
              <SudahDiambilIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>

            <Tabs.Panel value={menuListTeknisiStaf.project.subMenu.one.tabs.seven.flag}>
              <ProjectDibatalkanIndex
                stateMenu={menu}
                stateSubMenu={subMenu}
                stateTab={tab}

                fnRefreshNumber={() => { }}
              />
            </Tabs.Panel>
          </Tabs>
        </React.Fragment>
      }

      {menuListTeknisiStaf.project.subMenu.serialNumberChecker.flag === subMenu &&
        <React.Fragment>
          <WrapperHeaderTab>
            <HeaderNav
              stateMenuList={menuListTeknisiStaf}
              stateMenu={menu}
              stateSubMenu={subMenu}
            />
          </WrapperHeaderTab>

          <SerialNumberCheckerIndex
            stateMenu={menu}
            stateSubMenu={subMenu}
            stateTab={tab}
          />
        </React.Fragment>
      }
    </LayoutAppShell>
  )
}

export default ProjectTS;